import { call, put, all, takeEvery, select } from 'redux-saga/effects'

import {
  GET_FACEBOOK_PAGES,
  getFacebookPagesSuccess,
  getFacebookPagesFailure,
  GET_ACCESSIBLE_SOCIAL_PAGES,
  getAccessibleSocialPagesSuccess,
  getAccessibleSocialPagesFailure,
  ADD_ACCESSIBLE_SOCIAL_PAGES,
  addAccessibleSocialPagesSuccess,
  addAccessibleSocialPagesFailure,
  DELETE_ACCESSIBLE_SOCIAL_PAGES,
  deleteAccessibleSocialPagesSuccess,
  deleteAccessibleSocialPagesFailure,
  GET_INSTAGRAM_ACCOUNTS,
  getInstagramAccountsSuccess,
  getInstagramAccountsFailure,
  GET_FACEBOOK_PAGE_ACCESS_TOKEN,
  getFacebookPageAccessTokenSuccess,
  getFacebookPageAccessTokenFailure,
  CREATE_FACEBOOK_PAGE_ACCESS_REQUEST,
  createFacebookPageAccessRequestSuccess,
  createFacebookPageAccessRequestFailure,
  GET_BACKED_INSTAGRAM_ACCOUNTS,
  getBackedInstagramAccountsSuccess,
  getBackedInstagramAccountsFailure,
  getFacebookPagesLeadGenFormsSuccess,
  getFacebookPagesLeadGenFormsFailure,
  GET_FACEBOOK_PAGES_LEAD_GEN_FORMS,
  GET_FACEBOOK_DEBUG_TOKENS,
  getFacebookDebugTokensSuccess,
  getFacebookDebugTokensFailure
} from '../actions/socialAccounts'

import {
  getFacebookPagesService,
  getAccessibleSocialPagesService,
  addAccessibleSocialPagesService,
  getInstagramAccountsService,
  getFacebookPageAccessTokenService,
  getBackedInstagramAccountsService,
  deleteAccessibleSocialPagesService,
  createFacebookPageAccessRequestService,
  getFacebookPagesLeadGenFormsService,
  getFacebookDebugTokensService
} from '../services/socialAccounts'
import { selectedPartnershipIdSelector } from '../selectors/partnerships'
import { selectedFacebookAdAccountSelector } from '../selectors/adAccounts'

function* socialAccountsWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_FACEBOOK_DEBUG_TOKENS, getFacebookDebugTokensWorker),
    takeEvery(GET_FACEBOOK_PAGES_LEAD_GEN_FORMS, getFacebookPagesLeadGenFormsWorker),
    takeEvery(GET_FACEBOOK_PAGES, getFacebookPagesWorker),
    takeEvery(GET_ACCESSIBLE_SOCIAL_PAGES, getAccessibleSocialPagesWorker),
    takeEvery(ADD_ACCESSIBLE_SOCIAL_PAGES, addAccessibleSocialPagesWorker),
    takeEvery(DELETE_ACCESSIBLE_SOCIAL_PAGES, deleteAccessibleSocialPagesWorker),
    takeEvery(GET_FACEBOOK_PAGE_ACCESS_TOKEN, getFacebookPageAccessTokenWorker),
    takeEvery(CREATE_FACEBOOK_PAGE_ACCESS_REQUEST, createFacebookPageAccessRequestWorker),
    takeEvery(GET_INSTAGRAM_ACCOUNTS, getInstagramAccountsWorker),
    takeEvery(GET_BACKED_INSTAGRAM_ACCOUNTS, getBackedInstagramAccountsWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getFacebookPagesWorker({ params, skipContextPartnershipId }) {
  try {
    const response = yield call(getFacebookPagesService, params, skipContextPartnershipId)

    yield put(getFacebookPagesSuccess(response))
  } catch (e) {
    yield put(getFacebookPagesFailure(e))
  }
}

function* getAccessibleSocialPagesWorker({ params }) {
  try {
    const selectedPartnershipId = yield select(selectedPartnershipIdSelector)

    const { rightsHolderAccountId, ...restParams } = params || {}
    const contextFilter =
      // if rightsHolderAccountId is provided, use it to filter pages by rights holder
      rightsHolderAccountId
        ? {
            rights_holder: rightsHolderAccountId
          }
        : {
            partnership: selectedPartnershipId
          }
    const queryParams = {
      ...restParams,
      ...contextFilter
    }

    const response = yield call(getAccessibleSocialPagesService, queryParams)

    yield put(getAccessibleSocialPagesSuccess(response))
  } catch (e) {
    yield put(getAccessibleSocialPagesFailure(e))
  }
}

function* addAccessibleSocialPagesWorker({ pageData }) {
  try {
    const response = yield call(addAccessibleSocialPagesService, pageData)

    yield put(addAccessibleSocialPagesSuccess(response))
  } catch (e) {
    yield put(addAccessibleSocialPagesFailure(e))
  }
}

function* deleteAccessibleSocialPagesWorker({ id }) {
  try {
    yield call(deleteAccessibleSocialPagesService, id)

    yield put(deleteAccessibleSocialPagesSuccess(id))
  } catch (e) {
    yield put(deleteAccessibleSocialPagesFailure(e))
  }
}

function* getFacebookPageAccessTokenWorker({ facebookPageId }) {
  try {
    const selectedFacebookAdAccount = yield select(selectedFacebookAdAccountSelector)

    const params = {
      account: selectedFacebookAdAccount.id
    }

    const response = yield call(getFacebookPageAccessTokenService, params, facebookPageId)

    yield put(getFacebookPageAccessTokenSuccess(response, facebookPageId))
  } catch (e) {
    yield put(getFacebookPageAccessTokenFailure(e, facebookPageId))
  }
}

function* createFacebookPageAccessRequestWorker({ data }) {
  try {
    const response = yield call(createFacebookPageAccessRequestService, data)
    yield put(createFacebookPageAccessRequestSuccess(response))
  } catch (error) {
    yield put(createFacebookPageAccessRequestFailure(error))
  }
}

function* getInstagramAccountsWorker({ facebookPageId, accessToken }) {
  try {
    const selectedFacebookAdAccount = yield select(selectedFacebookAdAccountSelector)

    const params = {
      account: selectedFacebookAdAccount.id,
      page_access_token: accessToken
    }

    const response = yield call(getInstagramAccountsService, facebookPageId, params)
    yield put(getInstagramAccountsSuccess(response, facebookPageId))
  } catch (e) {
    yield put(getInstagramAccountsFailure(e, facebookPageId))
  }
}

function* getBackedInstagramAccountsWorker({ facebookPageId, accessToken }) {
  try {
    const selectedFacebookAdAccount = yield select(selectedFacebookAdAccountSelector)

    const params = {
      account: selectedFacebookAdAccount.id,
      page_access_token: accessToken
    }

    const response = yield call(getBackedInstagramAccountsService, facebookPageId, params)
    yield put(getBackedInstagramAccountsSuccess(response, facebookPageId))
  } catch (e) {
    yield put(getBackedInstagramAccountsFailure(e))
  }
}

function* getFacebookPagesLeadGenFormsWorker({ params }) {
  try {
    const response = yield call(getFacebookPagesLeadGenFormsService, params)
    yield put(getFacebookPagesLeadGenFormsSuccess(response))
  } catch (error) {
    yield put(getFacebookPagesLeadGenFormsFailure(error))
  }
}

function* getFacebookDebugTokensWorker({ params }) {
  try {
    const response = yield call(getFacebookDebugTokensService, params)
    yield put(getFacebookDebugTokensSuccess(response))
  } catch (error) {
    yield put(getFacebookDebugTokensFailure(error))
  }
}

export default socialAccountsWatcher
